// Vuex transaction module actions
import { API } from '@/config';
import { FILL_LIST } from './mutations-types';

export default {
  async getSupervisorsBelongsToUser({ commit }, projects) {
    const params = {
      projects,
    };
    try {
      const supervisors = await API.get('/user/getSupervisors', { params });
      commit(FILL_LIST, supervisors.data.data);
    } catch (err) {
      console.log(err);
    }
  },

};
